export default __webpack_public_path__ + "static/media/tavernier.f973aa37.svg";